<div class="teaser-text" [class.teaser-text--highlight]="highlight">
  <ng-content></ng-content>
</div>
